import React from "react";
import ImageGroupSelectImage from "./ImageGroupSelectImage";
import './ImageGroupSelect.scss';
import {ImageSelectEnums} from "../../config/enums";

export interface ImageSelectOption {
    key: string | ImageSelectEnums;
    name: string;
    showName?: string;
    src: string;
    srcBig?: string;
}

interface ImageGroupSelectProps {
    options: ImageSelectOption[];
    value: string | ImageSelectEnums;
    onChange: Function;
    small?: boolean;
    hideNames?: boolean;
    hoverEffect?: boolean;
}

/**
 * Component that defines an image-based option input
 * @param {ImageGroupSelectProps} props - The props that the ImageGroupSelect component accepts.
 * @param {ImageSelectOption[]} props.options - List of possible image-based options
 * @param {string | ImageSelectEnums} props.value - Current selected value
 * @param {Function} props.onChange - Function to change the current value
 * @param {boolean} props.small - Boolean which can be used to use a small version
 * @constructor
 */
const ImageGroupSelect = (props: ImageGroupSelectProps) => {
    const {onChange, options, value, hoverEffect, hideNames} = props;

    return <div className={'ImageGroupSelect' + (props.small ? ' small' : '')}>
        {options.map((option: ImageSelectOption, i: number) => <ImageGroupSelectImage hoverEffect={hoverEffect} hideNames={hideNames} key={i} name={option.name} showName={option.showName} src={option.src} active={option.key === value} onClick={() => onChange(option.key)} />)}
    </div>;
}

export default ImageGroupSelect;